
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CoverageHero() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="relative pt-28 sm:pt-36 pb-16 sm:pb-24 px-4 sm:px-6 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0F1E3C 0%, #1A3254 40%, #2A4A6B 100%)',
      }}
    >
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white/[0.03] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-20 w-80 h-80 bg-white/[0.04] rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-white/[0.04] rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-white/[0.03] rounded-full"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <p
          className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white/90 text-[13px] uppercase tracking-[2px] font-medium px-5 py-2 rounded-full mb-6 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-map-pin-line text-base"></i>
          </span>
          Service Coverage
        </p>
        <h1
          className={`text-white text-[30px] sm:text-[42px] lg:text-[52px] font-semibold leading-tight mb-5 transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Coverage Areas <br className="hidden sm:block" />
          <span className="text-white/70">Across California</span>
        </h1>
        <p
          className={`text-white/65 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto mb-8 transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Mediline Services delivers mobile MRI, CT, ultrasound, and X-ray solutions to healthcare facilities throughout California — from major metro hospitals to rural community clinics.
        </p>
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <a
            href="#regions"
            className="px-8 py-3.5 bg-white text-navy rounded-full font-semibold text-[15px] hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Explore Regions
          </a>
          <a
            href="/contact"
            className="px-8 py-3.5 border-2 border-white/30 text-white rounded-full font-medium text-[15px] hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Request Coverage Info
          </a>
        </div>
      </div>
    </section>
  );
}
